module.exports = __webpack_public_path__ + "static/media/SchoolEXTA0010_bg_clean_v001.d69667c5.webp";